import LoginForm from '../../organisms/LoginForm';

const LoginTemplate = ({
    backgroundImage,
    logo,
    loading,
    errorData,
    setErrorData,
    handleSubmit,
    onUserChange,
    onPasswordChange
    }) => { 

  return (

    <div
      className="sign-in-container"
      style={{ backgroundImage: `url(${backgroundImage})` }}>
      <div className="sign-in-overlay"></div>
      <LoginForm 
        logo={logo}
        loading={loading}
        errorData={errorData}
        setErrorData={setErrorData}
        handleSubmit={handleSubmit}
        onUserChange= {onUserChange}
        onPasswordChange= {onPasswordChange}
      />
      <div className="w-100 mb-2 position-absolute bottom-0 start-50 translate-middle-x text-white text-center">
        © Copyright 2024 GiantCargo - Todos os direitos reservados.
      </div>
    </div>
  );
};

export default LoginTemplate;
